angular.module('wbServices').factory 'users',
['$rootScope', 'railsResource', '$q', 'analytics', 'storage', '$window', 'User', 'Session', 'Password', 'TwoFactorAuth', '$http'
($scope, $resource, $q, analytics, storage, $window, User, Session, Password, TwoFactorAuth, $http) ->

  class UserService
    constructor: ->
      $scope.auth ?= {}
      $scope.auth.hasRole = (role) => @hasRole(role)
      @setCurrentUser($window.currentUser)

      $scope.$on 'resourceException', (event, response) =>
        if response.status is 401 && !response.data.noRedirection
          $window.location.reload()

    isSignedIn: =>
      $scope.auth.isSignedIn

    # Exclude roles is an array of roles that will block access if the user has that role
    checkSignin: (roles, excludeRoles = null) =>
      deferred = $q.defer()
      if excludeRoles && @hasRoles(excludeRoles)
        deferred.reject("403")
      else if !roles? || @hasRoles(roles)
        deferred.resolve(@getCurrentUser())
      else
        deferred.reject("403")
      deferred.promise

    setCurrentUser: (user) =>
      if user?
        storage.setItem('user', @currentUserAsJson(user))
        $scope.auth.isSignedIn = true
        $scope.auth.currentUser = user
      else
        $scope.auth.isSignedIn = false

    currentUserAsJson: (user) =>
      JSON.stringify({
        id: user.id,
        email: user.email
        language: user.language
        hasAdvisor: user.has_external_advisor,
        isGroupPlanUser: user.is_group_plan_user
      })

    getCurrentUser: =>
      $scope.auth.currentUser ||= JSON.parse(storage.getItem('user'))

    hasRole: (role) =>
      _.includes(@getCurrentUser()?.roles, role)

    hasRoles: (roles) =>
      _(roles).intersection(@getCurrentUser()?.roles).some()

    hasPrefs: (pref) =>
      _(pref).intersection(@getCurrentUser()?.properties).some()

    create: (params = {}, options = {}) =>
      User.create(params).$promise
        .then @setLoginData

    signin: (user = {}) =>
      Session.create({
        email: user.email,
        password: user.password
      }).$promise.then @setCurrentUser

    resetPassword: (params, options = {}) =>
      Password.create(params, options.success, options.error).$promise

    verifyResetPassword: (params, options) =>
      Password.get(params, options.success, options.error).$promise

    updatePassword: (params, options = {}) =>
      Password.update({}, params).$promise
        .then options.success
        .catch options.error

    sendEmailConfirmation: (params, options = {}) =>
      User.sendEmailConfirmation(params).$promise

    isMigrated: (email) =>
      $http.post('/dashboard-api/migrated', { email: email })

    # 2FA
    twoFactorInfo: (rememberDeviceToken) =>
      $resource('/two-factor-auth/info').get().$promise
        .then (data) => data

    enableTwoFactorAuth: (phone, tfaMethod) =>
      phone = phone || false
      TwoFactorAuth.create({phone: phone, tfaMethod: tfaMethod}).$promise.then (user) =>
        user

    disableTwoFactorAuth: =>
      TwoFactorAuth.delete().$promise.then (user) =>
        user

    requestTwoFactorAuth: (phone = {}) =>
      TwoFactorAuth.get(phone).$promise.then (r) =>
        r.qrCode

    confirmTwoFactorAuth: (token, rememberDevice) =>
      rememberDevice = rememberDevice || false
      TwoFactorAuth.update({
        token: token,
        rememberDevice: rememberDevice
      }).$promise.then (user) =>
        user

    confirmTwoFactorAuthForResetPassword: (token) =>
      $resource('/two-factor-auth/reset-password').update({ token: token }).$promise
        .then (data) => data

    revokeDeviceAccess: (id) =>
      $resource('/tokens/:id', {id: id}).delete().$promise

    skipTwoFactorAuth: =>
      $resource('/two-factor-auth/skip').save().$promise
        .then (data) => data

    rememberDeviceTwoFactorAuth: =>
      $resource('/two-factor-auth/remember-device').save().$promise
        .then (data) => data

    generateApiKey: (name) =>
      $resource('/api_keys', {name}).save().$promise
        .then (data) => data

    getApiKeys: =>
      $resource('/api_keys').get().$promise
        .then (data) => data

    deleteApiKey: (id) =>
      $resource('/api_keys', {id}).delete().$promise
        .then (data) => data

    generateDataPortabilityCsv: =>
      $http.post('/api/data-portability/export')

  new UserService()
]
